import React, { useEffect } from 'react';

export const RedirectComponent = () => {
    useEffect(() => {
        window.location.href = 'https://www.gjensidige.se';
    }, []);
    return <div></div>;
};
